import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type PocketByType = paths['/v4/pockets/{type}/'];

const getPocketByType = createRequest<PocketByType>('/pc/v4/pockets/{type}/');

export default getPocketByType;
